/**
 * Key points on a video (Coleman, 2026-11-01: "99% of the key points are ai-generated and not very useful. i say we
 * just hide them. and use them only for searchability"). Not shown on any screen; still in the search bar's match
 * (SearchBar.jsx) and still readable by BAM IQ. Set of the Day's point is his own and stays (setOfDay.js).
 * Turning them back on is this one switch.
 */
export const SHOW_KEY_POINTS = false;

/** The key points a screen should show for an item: none while they're hidden. */
export const shownKeyPoints = (item) => (SHOW_KEY_POINTS && Array.isArray(item?.keyPoints) ? item.keyPoints.filter(Boolean) : []);
